var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuForm',{attrs:{"url":_vm.url,"menu":_vm.menu,"errors":_vm.errors,"routes":_vm.routes},on:{"onUpdateMenu":_vm.onUpdateMenu,"save":_vm.saveMenu}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8a7b0fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/menu/MenuEdit.vue
// module id = null
// module chunks = 